import {FETCH_FOOTER_REQUEST, FETCH_FOOTER_SUCCES, FETCH_FOOTER_ERROR} from '../constants/Footer'
import { jsonGet, errorHandler } from '../utils/Request';

const loadFooterLinks = () => (dispatch) => {
  const apiUrl = '/config/footer-links/';
  dispatch({
    type: FETCH_FOOTER_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_FOOTER_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_FOOTER_ERROR
      });
      errorHandler(e);
    });
};

export { loadFooterLinks };



// WEBPACK FOOTER //
// ./src/actions/FooterActions.js